"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHotelCheapestPackageForDate = void 0;
const dayjs = require("dayjs");
const getPackageTotalCostForDate_1 = require("./getPackageTotalCostForDate");
const getHotelCheapestPackageForDate = (date, pkgs) => {
    // get a list of room prices for all packages
    if (!date) {
        date = dayjs().toISOString();
    }
    const prices = pkgs.map((pkg) => {
        return (0, getPackageTotalCostForDate_1.getPackageTotalCostForDate)(date, pkg);
    });
    // get the lowest price
    const lowest_price = Math.min(...prices);
    return lowest_price;
};
exports.getHotelCheapestPackageForDate = getHotelCheapestPackageForDate;
